import React, { useState } from "react";
import { formatStamp } from "../utils/chatUtils";
import MessageStatusIcon from "./MessageStatusIcon";
import { resolveMediaUrl } from "../utils/url";

export default function ConversationSidebar({
  items,                 // Ergebnis von buildConversationList(...)
  user,                  // aktueller User
  activeUser,            // aktuell geöffnete Konversation
  onOpen,                // (item) => void  -> openConversation
  allUsers,              // Liste aller Nutzer für "Neue Konversation"
  onStartNewConversation // (userId:number) => Promise<void>
}) {
  const [showNewConv, setShowNewConv] = useState(false);
  const [newConvUserId, setNewConvUserId] = useState("");

  return (
    <div className="chat-sidebar" style={{ width: 220, background: '#23272b', borderRadius: 16, margin: 12, padding: 16, flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'stretch' }}>
      <h2>Konversationen</h2>

      <button
        className="chat-newconv-btn"
        onClick={() => setShowNewConv(v => !v)}
      >
        Neue Konversation starten
      </button>

      {showNewConv && (
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const uid = Number(newConvUserId);
            if (!uid) return;
            await onStartNewConversation(uid);
            setShowNewConv(false);
            setNewConvUserId("");
          }}
          style={{ marginTop: 12 }}
        >
          <select
            value={newConvUserId}
            onChange={(e) => setNewConvUserId(e.target.value)}
          >
            <option value="">— Nutzer wählen —</option>
            {allUsers
              .filter(u => Number(u.id) !== Number(user?.id))
              .map(u => (
                <option key={u.id} value={u.id}>
                  {u.displayName || u.username}
                </option>
              ))}
          </select>
          <button type="submit" style={{ marginLeft: 8 }}>Öffnen</button>
        </form>
      )}

      <ul className="chat-conv-list" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {items.map((c) => {
          const isActive = activeUser?.userId === c.userId;
          const isUnread = !!c.isUnread;
          return (
            <li
              key={c.userId}
              className={`chat-conv-item ${isActive ? "active" : ""} ${isUnread ? "unread" : ""}`}
              onClick={() => onOpen(c)}
              style={{
                padding: '10px 8px',
                borderRadius: 8,
                marginBottom: 6,
                background: isActive
                  ? '#2a3a4d'
                  : isUnread
                    ? '#3a4d2a'
                    : 'transparent',
                boxShadow: isUnread ? '0 0 0 2px #2ecc40' : undefined,
                cursor: 'pointer',
                transition: 'background 0.2s, box-shadow 0.2s',
                display: 'flex',
                alignItems: 'center',
                gap: 12,
              }}
            >
              <img
                src={resolveMediaUrl(c.avatarUrl || '/avatars/default-avatar.png')}
                alt="Profilbild"
                style={{ width: 38, height: 38, borderRadius: '50%', objectFit: 'cover', background: '#444' }}
              />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 15, color: '#e0e6ed' }}>
                  {c.displayName || c.username}
                </div>

                {c.preview && (
                  <div style={{
                    display: 'flex', alignItems: 'center', gap: 6,
                    fontSize: 13, color: '#b0b8c0', marginTop: 2,
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'
                  }}>
                    <span>{c.preview}</span>

                    {Number(c.lastSenderId) === Number(user?.id) && (
                      <span>
                        
                        {Number(c.lastSenderId) === Number(user?.id) && (
                            <MessageStatusIcon delivered={!!c.lastDelivered} read={!!c.lastRead} size={14} />
                        )}
                        
                      </span>
                    )}
                  </div>
                )}

                {c.lastMessageAt && (
                  <div style={{ fontSize: 12, color: '#8a98a8', marginTop: 2 }}>
                    {formatStamp(c.lastMessageAt)}
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
